import { render, staticRenderFns } from "./CreateUpdateClient.vue?vue&type=template&id=208fe52d&scoped=true&"
import script from "./CreateUpdateClient.vue?vue&type=script&lang=ts&"
export * from "./CreateUpdateClient.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208fe52d",
  null
  
)

export default component.exports